import { useState } from "react";
import { CabeceraTable } from "../../../components/Table/CabeceraTable";
import {
  IColumn,
  ICommandBarItemProps,
  IconButton,
  Stack,
} from "@fluentui/react";
import IconHelper from "../../../utils/helpers/iconHelper";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelAddModeloEquipo } from "./PanelAddModeloEquipo";
import { useAsignacionEquipos } from "../../../hooks/CheckList/Configuraciones/useAsignacionEquipos";
import { PanelAddEquipoPorModelo } from "./PanelAddEquipoPorModelo";
import { IDatoModeloEquipo } from "../../../Interfaces/ListaVerificacion/Equipo/IEquiposCheckList";
import { TableBase2 } from "../../../components/Table/TableBase2";
import { PaginationFooterC } from "../../../components/PaginationFooter/PaginationFooterC";

export const ConfigModelosEquipos = () => {
  const [isOPenPanel, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);
  const [
    isOPenPanelEquipo,
    { setTrue: openPanelEquipo, setFalse: dismissPanelEquipo },
  ] = useBoolean(false);
  const [datosModeloEquipo, setDatosModeloEquipo] = useState<IDatoModeloEquipo>(
    null!
  );

  const {
    loading,
    item,
    paginacion,
    searchBoxRefTable,
    _onkeyUpSearchModeloEquipo,
    onClickRefresh,
    onChangeSkip,
  } = useAsignacionEquipos();

  const _items: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD,
      onClick: () => {
        openPanel();
      },
    },
    {
      ...IconHelper.ICON_RELOAD,
      onClick: () => {
        onClickRefresh();
      },
    },
  ];

  const column: IColumn[] = [
    {
      key: "modelo",
      name: "Modelo",
      fieldName: "equipo",
      minWidth: 300,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "tipoEquipo",
      name: "TIpoEquipo",
      fieldName: "tipoEquipo",
      minWidth: 180,
      maxWidth: 180,
      isResizable: true,
      isMultiline: true,
    },
    {
      key: "fechaCreado",
      name: "Fecha de Creación",
      fieldName: "fecha",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
    },
    {
      key: "opciones",
      name: "Opciones",
      fieldName: "opciones",
      minWidth: 150,
      maxWidth: 150,
      isResizable: true,
      onRender: (item: any) => {
        return (
          <IconButton
            iconProps={{ iconName: "Add", style: { fontSize: "12px" } }}
            title="Add"
            style={{ height: "10px" }}
            onClick={() => {
              setDatosModeloEquipo({
                ...datosModeloEquipo,
                nombreModelo: item.equipo,
                modeloEquipoId: item.equipoModeloId,
              });
              openPanelEquipo();
            }}
            ariaLabel="Add"
          />
        );
      },
    },
  ];
  return (
    <>
      <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg12">
          <CabeceraTable
            placeholder="Buscar Por Modelo"
            componentRef={searchBoxRefTable}
            Titulo="Modelo de Equipos"
            SubTitulo="Gestión de Modelo de Equipos"
            onKeyUp={_onkeyUpSearchModeloEquipo}
          />
        </div>
      </div>
      <br />
      <Stack>
        <TableBase2
          leftBar={_items}
          data={item}
          column={column}
          isLoading={loading}
          footerPagination={
            <PaginationFooterC
              paginacion={paginacion}
              onChangePagina={(e) => {
                onChangeSkip(e);
              }}
            />
          }
        />
      </Stack>
      <PanelAddModeloEquipo
        isOpen={isOPenPanel}
        onDismiss={dismissPanel}
        onRefreshTable={onClickRefresh}
      />
      <PanelAddEquipoPorModelo
        datosModeloEquipo={datosModeloEquipo}
        isOpen={isOPenPanelEquipo}
        onDismiss={dismissPanelEquipo}
      />
    </>
  );
};
